var React = require('react');

function Excavator (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Excavator"),React.createElement("g",{"id":"layer1","key":2},[React.createElement("path",{"id":"path1470","className":"cls-1","d":"M14,73.71l40-40H74l40,40","key":0}),React.createElement("path",{"id":"path1476","className":"cls-1","d":"M94,53.71l-20,20H54l-20-20","key":1}),React.createElement("path",{"id":"path1478","className":"cls-1","d":"M54,73.71v30H74v-30","key":2})])]);
}

Excavator.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Excavator;

Excavator.default = Excavator;
